// extracted by mini-css-extract-plugin
export default {"overlay":"py-z","bodyOpen":"qy-z","content":"ry-z","header":"sy-z","close":"ty-z","closeNoHeading":"uy-z"};